import React, { useState, useEffect } from "react";
import Cf7FormWrapper from "./Cf7FormWrapper";
import ContactForm from "./ContactForm";

const SubContactForm = (props) => {
  return (
    <Cf7FormWrapper id="202">
      <ContactForm subprops={props} />
    </Cf7FormWrapper>
  )
}

export default SubContactForm;